module.exports = "/_next/static/images/placeholder-logo-1a7ca5a600667376ad17f0c3df5366ec.png";